import { TOKENS } from '../../hooks/useTheme';
import type { Theme } from '../../types';

interface SyntaxBgProps {
  theme: Theme;
}

export function SyntaxBg({ theme }: SyntaxBgProps) {
  const op = theme.dark ? 0.1 : 0.14;
  const lines = [
    {
      x: '70%',
      y: 280,
      content: (
        <span>
          <span style={{ color: theme.acc }}>function</span>{' '}
          <span style={{ color: TOKENS.fn }}>ship</span>() {'{'}
        </span>
      ),
    },
    {
      x: '72%',
      y: 304,
      content: (
        <span>
          {'  '}
          <span style={{ color: theme.acc }}>return</span>{' '}
          <span style={{ color: TOKENS.kw }}>'one thing'</span>;
        </span>
      ),
    },
    { x: '70%', y: 328, content: <span>{'}'}</span> },
    {
      x: '6%',
      y: 720,
      content: (
        <span style={{ color: TOKENS.comment }}>{'// the boring web, in order.'}</span>
      ),
    },
    {
      x: '78%',
      y: 1180,
      content: (
        <span>
          <span style={{ color: theme.acc }}>await</span> patience;
        </span>
      ),
    },
    {
      x: '6%',
      y: 1480,
      content: <span style={{ color: TOKENS.comment }}>{'// — m'}</span>,
    },
  ];

  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        zIndex: 0,
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: 11,
        opacity: op,
      }}
    >
      {lines.map((l, i) => (
        <div
          key={i}
          style={{
            position: 'absolute',
            left: l.x,
            top: l.y,
            color: theme.fg,
            whiteSpace: 'pre',
          }}
        >
          {l.content}
        </div>
      ))}
    </div>
  );
}
